import React, { useEffect, useState } from "react";
import { FieldArray } from "formik";
import { connect } from "react-redux";
import { Grid, Header, Table, Pagination, Input, Checkbox } from "semantic-ui-react";
// import { Checkbox } from "formik-semantic-ui";
import moment from "moment";
import PoDetails from "./poDetails";
import { selectSoData, clearSelectPoData } from "../../redux/actions/purchaseOrderActions";
import { PO_TITLES } from "../../config/const";

const ActivePurchaseOrder = ({
  editmode,
  vendorData,
  viewmode,
  masterState,
  vendorStateId,
  updatePurchaseOrder,
  getVendorPurchaseOrder,
  purchaseOrderPaginationData,
  handlePaginationChangeCall,
  purchaseOrderCurrentPageData,
  setInitialize,
  handleSearchStringCall,
  searchTextProps,
  hidePagination,
  selectedPOs,
  billData,
  vendorName,
  ...props
}) => {

  const {
    selectedCheck,
    selectSoData,
    allSoIds,
    clearSelectPoData
  } = props;

  const [searchText, setSearchText] = useState(searchTextProps);
  const [editLoading, setEditLoading] = useState(false);
  const [vendorFlag, setVendorFlag] = useState(true)

  const searchString = (e) => {
    if (e.keyCode == 13) {
      handleSearchStringCall(e.target.value);
    }
  };

  const handlePaginationChange = (e, { activePage }) => {
    handlePaginationChangeCall(activePage);
  };
    

  return (
    <div className="ui form mt-5">
      <FieldArray name="activePODetails">
        {({ push, remove, form }) => {
          const { values } = form;
          // const { activePODetails } = values;
          const activePODetails = props.activePOs
          let temp = []
          if(values.vendorName == ''){
            setVendorFlag(false)
          }
          if(activePODetails){           
            activePODetails.forEach((obj) => {
            if(obj.checkbox == true){
              temp.push(obj)
            }
           })
          }
          values.activeSOSelected = selectedCheck

          let manualPoAddedTotal = isNaN(values.manualPoAddedTotal)
            ? 0
            : + values.manualPoAddedTotal

          let totalActivePOAmount = 
            values.vendorName && 
                selectedCheck?.length > 0 ? 
                  values.isGstApplicable ? Number(selectedCheck.map(item => item.poAmount).reduce((prev, next) => parseFloat(prev) + parseFloat(next))).toFixed(2)
                  : Number(selectedCheck.map(item => item.taxableAmount).reduce((prev, next) => parseFloat(prev) + parseFloat(next))).toFixed(2)
                  : 0

          return (
            <>
          <div className="text-center font-weight-bold mt-6">
                      <span>
                          {PO_TITLES.UNMAPPED_PO}
                </span>
              </div>
              {activePODetails?.length > 0 && <div class="ui focus input pb-2" style={{ float: "right" }}>
                <input
                  type="text"
                  defaultValue={searchText}
                  placeholder="Search Purchase Order Number	..."
                  onKeyUp={searchString}
                />
              </div>}
              {
                selectedCheck && selectedCheck?.length > 0 && values.vendorName  ?
                  <>
                    <br />
                    <br />
                    <b> Selected PO</b>
                    <Table unstackable size="large" compact="very" className="w3-small">
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell className="labelName p-bold-600">PO Number</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">Order Number</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">LR Number</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">Vendor LR Number</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">Reference Number</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">PO Date</Table.HeaderCell>
                          <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {(selectedCheck).map((object, index) => {
                          return (
                            <Table.Row verticalAlign="middle">

                              <React.Fragment>
                                <Table.Cell>
                                  {object.poNumber}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.orderNo}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.lrNo}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.vendorLrNo}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.poReferenceNo}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.poDate ? moment(object.poDate).format("DD-MM-YYYY") : 'NA'}
                                </Table.Cell>
                                <Table.Cell>
                                  {object.totalOrderAmt}
                                </Table.Cell>
                              </React.Fragment>
                            </Table.Row>
                          )
                        }
                        )}
                      </Table.Body>
                    </Table>
                  </>
                  : null

              }
              <Table
                unstackable
                size="large"
                compact="very"
                className="w3-small"
              >
                <Table.Header>
                  <Table.Row>
                    {viewmode ? (
                      ""
                    ) : (
                      <Table.HeaderCell className="labelName p-bold-600"></Table.HeaderCell>
                    )}
                    <Table.HeaderCell className="labelName p-bold-600">
                      PO Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      Order Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      LR Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      Vendor LR Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      Reference Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      PO Date
                    </Table.HeaderCell>
                    {/* <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell> */}
                    <Table.HeaderCell className="labelName p-bold-600">
                      Amount
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

               {activePODetails?.length > 0 ?  <Table.Body>
                  {activePODetails.map((object, index) => {
                    return (
                      <Table.Row verticalAlign="middle">
                        <React.Fragment>
                          {viewmode ? (
                            ""
                          ) : (
                            <Table.Cell>
                              <Checkbox
                                onChange ={(e,data) => selectSoData(object) }
                                name={`activePODetails[${index}].checkbox`}
                                value={activePODetails?.[index]?.checkbox}
                                inputProps={{ disabled: object?.isEditable }}
                                checked={allSoIds.includes(object.poId) ? true : false}
                              />
                            </Table.Cell>
                          )}
                          <Table.Cell>
                            {activePODetails[index].poNumber}
                            <PoDetails
                              poId={activePODetails[index].poId}
                              poReferenceNo={
                                activePODetails[index].poReferenceNo
                              }
                              masterState={masterState}
                              vendorStateId={vendorStateId}
                              isGstApplicable={values.isGstApplicable}
                              updatePurchaseOrder={updatePurchaseOrder}
                              getVendorPurchaseOrder={getVendorPurchaseOrder}
                              setInitialize={setInitialize}
                              formValues={values}
                              editmode={editmode}
                              vendorData={vendorData}
                              viewmode={viewmode}
                            />
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].orderNo}
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].lrNo}
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].vendorLrNo}
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].poReferenceNo}
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].poDate
                              ? moment(activePODetails[index].poDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "NA"}
                          </Table.Cell>
                          <Table.Cell>
                            {activePODetails[index].totalOrderAmt}
                          </Table.Cell>
                        </React.Fragment>
                      </Table.Row>
                    );
                  })}
                </Table.Body> :
                 <Table.Body className='text-center'>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  {/* <Table.Cell></Table.Cell> */}
                  <Table.Cell>{'No Data found'}</Table.Cell>
                </Table.Body>}
              </Table>
              <Grid columns={3}>
                <Grid.Row className="p-2">
                  <Grid.Column width={10} />
                  <Grid.Column>
                    {editmode ? (
                      ""
                    ) : (
                      <>
                        <Grid.Row>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName p-bold-600"
                            size="tiny"
                          >
                            Active PO Total
                          </Header>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName"
                            size="tiny"
                          >
                            ₹ { totalActivePOAmount ? totalActivePOAmount : "0.00"}
                          </Header>
                        </Grid.Row>
                        <Grid.Row>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName p-bold-600"
                            size="tiny"
                          >
                            New PO Total
                          </Header>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName"
                            size="tiny"
                          >
                            ₹{" "}
                            {isNaN(values.manualPoAddedTotal)
                              ? "0.00"
                              : values.manualPoAddedTotal}
                          </Header>
                        </Grid.Row>
                      </>
                    )}
                    <Grid.Row className='mt-5'>
                      <Header
                        floated="right"
                        as="label"
                        className="labelName p-bold-600 mt-6"
                        size="tiny"
                      >
                        Total
                      </Header>
                      <Header
                        floated="right"
                        as="label"
                        className="labelName"
                        size="tiny"
                      >
                        ₹ {manualPoAddedTotal + 
                          + totalActivePOAmount}
                      </Header>
                    </Grid.Row>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              {hidePagination == true || activePODetails?.length == 0 ? null : (
                <div
                  style={{ marginLeft: "-15px", borderTop: "0px solid black" }}
                >
                  <Pagination
                    defaultActivePage={
                      purchaseOrderCurrentPageData
                    } /* {currentPageNo} */
                    activePage={typeof purchaseOrderCurrentPageData === "object" ? purchaseOrderCurrentPageData.currentPage : purchaseOrderCurrentPageData}
                    firstItem={null}
                    lastItem={null}
                    onPageChange={handlePaginationChange}
                    pointing
                    secondary
                    totalPages={
                      purchaseOrderPaginationData?.totalPages
                        ? purchaseOrderPaginationData.totalPages
                        : 0
                    }
                  />
                </div>
              )}
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

const mapStatetoProps = (state) => ({
  selectedCheck: state.generatePdfData.allCheckData,
  allSoIds: state.generatePdfData.allSoIds
})

export default connect(mapStatetoProps, { selectSoData ,clearSelectPoData})(ActivePurchaseOrder)
